const ParamListFields = Object.freeze({
  ValueCode: 'ValueCode',
  ValueOrder: 'ValueOrder',
  ValueDesc: 'ValueDesc',
});

export default ParamListFields;
